import React, { forwardRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import Slide from "@material-ui/core/Slide";
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Popup = ({ open = false, handleClose, images = [] }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ className: "w-100" }}
    >
      <DialogContent className="w-100">
        {images?.map?.((el) => {
          return (
            <div className="img_outer">
              {el.type === "image" ? (
                <img src={el.src} className={`img`} alt={el.type} />
              ) : el.type === "video" ? (
                <video
                  autoPlay
                  loop
                  playsInline
                  className={`w-100 h-100 overflow-hidden mask`}
                  src={el?.src}
                ></video>
              ) : (
                <div>The File You've uploaded is not Correct</div>
              )}
            </div>
          );
        })}
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
